import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function AudiencesReceiveOutreach() {
    return (
        <OnboardingBody title={<span>Audiences receive outreach</span>}>
            <div>
                <p>
                    An audience is an organized list of people who will receive your outreach. The
                    members of an audience can change over time, too.
                    <br />
                    <br />
                    Tailor your outreach to the right people by creating unique audiences for
                    different messages.
                </p>
            </div>
        </OnboardingBody>
    );
}
